import { useEffect, useState } from 'react';
import { useDevList } from '../../data';

export default (function (lines) {
  const [ids, setIds] = useState([]);
  const [devs, exec, url] = useDevList({ manual: true });
  const [orderlyDevs, sortDevs] = useState([]);

  useEffect(() => {
    let ids = [];
    lines.forEach(line => {
      if (line.machine_ids) {
        ids = [...line.machine_ids, ...ids];
      }
    });
    if (ids.length > 0) {
      setIds(ids);
    }
  }, [lines]);

  useEffect(() => {
    if (ids.length > 0) {
      const newUrl = `${url}?ids=${ids.join(',')}`;
      exec(newUrl);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ids]);

  useEffect(() => {
    devs.sort((prev, next) => {
      const p = ids.indexOf(prev.id);
      const n = ids.indexOf(next.id);
      return p - n;
    });
    if (devs.length > 0) sortDevs(JSON.parse(JSON.stringify(devs)));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [devs]);

  return orderlyDevs;
});
